export const PLAN_FRAME = 'cg-plan-diagram';
export const PLAN_FRAME_READ_ONLY = 'cg-plan-diagram-ro';
export const PLAN_FRAME_SOURCE = 'cg-plan-frame';

const framed = () => {
  if (typeof window === 'undefined') return false;
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const inPlanFrame = () =>
  framed() && (window.name === PLAN_FRAME || window.name === PLAN_FRAME_READ_ONLY);

export const planFrameReadOnly = () => inPlanFrame() && window.name === PLAN_FRAME_READ_ONLY;

export const planFrameMessage = (target, message) =>
  target?.postMessage({ source: PLAN_FRAME_SOURCE, ...message }, window.location.origin);

export const postToPlan = (message) => {
  if (inPlanFrame()) planFrameMessage(window.parent, message);
};

export const isPlanFrameMessage = (event, from) =>
  event.origin === window.location.origin &&
  event.source === from &&
  event.data?.source === PLAN_FRAME_SOURCE;
